import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Outlet, Link } from 'react-router-dom'
import { Card } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
const { Meta } = Card

import { useGameNews } from 'data/hooks'


export const News = props => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { news } = useGameNews(gameId)
  const { newId } = useParams()
  const navigate = useNavigate()

  return (<>

      { newId ?
        <Outlet />
      :
        <div className="game-news">
          {
            news.map(n =>
              <Card
                className="new-card"
                hoverable
                onClick={() => navigate(`${n.ID}`)}
                cover={n.image && <img alt="example" src={n.image} />}
                actions={[
                  <div className="date">{new Date(n.post_date).toLocaleDateString()}</div>,
                  <Link className="detail" to={`${n.ID}`}><EyeOutlined /> Ver detalle</Link>
                ]}        
              >
                <Meta 
                  title={n.post_title} 
                  description={n.post_excerpt} 
                />
              </Card>
            )
          }
        </div>
      }
  </>)
}
